import { Component } from '@angular/core';

@Component({
  selector: 'aig-main-text',
  imports: [],
  templateUrl: './main-text.component.html',
  styleUrl: './main-text.component.scss'
})
export class MainTextComponent {

}
